import type { UpcomingCorridor } from "@/app/utils/network";

/**
 * Next African corridors, shown with a "Coming soon" badge (SPEC 5.4).
 *
 * Not in the countries API yet, so this config is the source of truth for the
 * upcoming list. Order matters: it is the display order. When the API starts
 * reporting one of these countries, `network.activeUpcoming` drops it from the
 * list automatically and it shows as Live with no code change; remove it from
 * here afterwards to keep the config tidy.
 */
export const UPCOMING_CORRIDORS: UpcomingCorridor[] = [
  { code: "NG", name: "Nigeria", currencyCode: "NGN", currencySymbol: "₦" },
  { code: "SN", name: "Senegal", currencyCode: "XOF", currencySymbol: "Fr" },
  { code: "GH", name: "Ghana", currencyCode: "GHS", currencySymbol: "₵" },
  { code: "CI", name: "Côte d’Ivoire", currencyCode: "XOF", currencySymbol: "Fr" },
];

/**
 * Display order of the coming-soon currency groups (calculator menu and the
 * Exchange Rates strip). Currencies not listed here sort after these.
 */
export const UPCOMING_CURRENCY_ORDER = ["NGN", "GHS", "XOF"] as const;

/**
 * Delivery line in the calculator, derived from the destination's payout
 * methods. Only these two methods exist (SPEC 1).
 */
export const PAYOUT_LABELS = {
  bankAndMobile: "Bank deposit or mobile money",
  bank: "Bank deposit",
  mobile: "Mobile money",
} as const;
